// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { AssetLifecycleStateSchema } from '../inputTypeSchemas/AssetLifecycleStateSchema'
import { AssetLifecycleStateOriginSchema } from '../inputTypeSchemas/AssetLifecycleStateOriginSchema'

/////////////////////////////////////////
// ASSET LIFECYCLE SCHEMA
/////////////////////////////////////////

export const AssetLifecycleSchema = z.object({
  state: AssetLifecycleStateSchema,
  origin: AssetLifecycleStateOriginSchema.nullable(),
})

export type AssetLifecycle = z.infer<typeof AssetLifecycleSchema>

export default AssetLifecycleSchema;
